export default function buildCloseSession({
    apiEndpoint,
    apiTools
}) {
    return async function closeSession(args) {
        const url = apiTools.resolveUrl({
            ...args,
            apiEndpoint: `${ apiEndpoint }/logout` 
        })
       
        const res = await fetch(url, {
            method: 'POST',
            headers: {
                'Content-type': 'application/json',
                'Authorization': 'salaTokken'
            },
            credentials: 'include',
        });
        return await res.json();
    }
}